<template>
  <div>
    <b-card class="m-3" no-body>
      <template #header>
        <h6 class="mb-0 text-center titulo-sagres font-weight-bold">
          Relatório Servidores com mais de dois Vínculos
        </h6>
      </template>
      <b-form v-if="!blockForm" class="m-2" @submit.stop.prevent="gerarRelatorio">
        <b-row>
          <b-col cols="12" xl="2">
            <b-form-group id="input-group-exercicio" label="Exercício *" label-for="input-exercicio"
              label-class="text-left">
              <b-form-select id="input-exercicio" v-model="filtros.exercicio" :options="exercicios"
                :disabled="desabilitarSm2v || loading"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="2">
            <b-form-group id="input-group-mes" label="Mês Referência *" label-for="input-mes" label-class="text-left">
              <b-form-select id="input-mes" v-model="filtros.mes" :options="meses"
                :disabled="desabilitarSm2v || loading"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="2">
            <b-form-group id="input-group-formato" label="Formato" label-for="input-formato" label-class="text-left">
              <b-form-select id="input-formato" v-model="filtros.formato" :options="formatos"
                :disabled="desabilitarSm2v || loading"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="4">
            <b-form-group id="input-group-ug" label="Unidade Gestora" label-for="input-ug" label-class="text-left">
              <span style="float: left"><strong>{{ nomeUgLogado }}</strong></span>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="2" class="d-flex align-items-center justify-content-end">
            <b-button class="mr-2" size="md" variant="secondary" type="submit" :disabled="desabilitarSm2v || loading">
              <font-awesome-icon icon="file-alt" class="mr-2" />
              Gerar Relatório
            </b-button>
          </b-col>
        </b-row>
      </b-form>
      <div v-else class="text-center">
        <b-spinner label="Carregando..."></b-spinner>
      </div>
    </b-card>
    <div v-if="loading" class="text-center">
      <b-spinner label="Carregando..."></b-spinner>
    </div>
    <pdf-viewer v-if="!loading && pdfData" :data="pdfData" :filename="filename" />
  </div>
</template>

<script>
import reportService from '@/services/reportService'
import PdfViewer from "@/components/PdfViewer.vue"
import { UtilsTS } from '@/utilsts'
import { FiltrosGestao } from '@/types/relatorios/filtros-gestao'

export default {
  mixins: [UtilsTS],
  components: {
    PdfViewer
  },
  data() {
    return {
      filename: null,
      pdfData: null,
      desabilitarSm2v: false,
      meses: [],
      formatos: [
        { value: "PDF", text: 'PDF' },
        { value: "excelopenxml", text: 'Planilha' },
      ],
      exercicios: [],
      filtros: {
        exercicio: null,
        mes: null,
        formato: "PDF",
        ug: null,
        idArea: null,
      },
      nomeUgLogado: null,
      loading: false,
      blockForm: false,
    }
  },
  methods: {
    async prepararSm2v() {
      try {
        this.blockForm = true
        const prepararSm2vResponse = await reportService.prepararSm2v()
        if (prepararSm2vResponse && prepararSm2vResponse.status == 200) {
          this.desabilitarSm2v = prepararSm2vResponse.data.desabilitarSM2V
          if (!this.desabilitarSm2v) {
            this.exercicios = prepararSm2vResponse.data.exercicios.map(e => {
              return { value: e, text: e }
            })
            this.filtros.exercicio = this.exercicios[0].value
            this.filtros.mes = this.meses[0].value
            this.filtros.ug = prepararSm2vResponse.data.codigoUG
            this.filtros.idArea = prepararSm2vResponse.data.idArea
            this.nomeUgLogado = prepararSm2vResponse.data.nomeUG
          }
          else {
            this.$toast.error('erro ao preparar relatório')
          }
        }
        else {
          this.$toast.error('erro ao preparar relatório')
        }
      } catch (e) {
        console.error('Erro ao preparar sm2v', e.message, e.stack)
        this.$toast.error('erro ao preparar relatório')
      } finally {
        this.blockForm = false
      }
    },

    async gerarRelatorio() {
      try {
        this.pdfData = null;
        this.loading = true;
        const ftr = new FiltrosGestao()
        ftr.exercicio = this.filtros.exercicio
        ftr.mes = this.filtros.mes
        ftr.ug = this.filtros.ug
        ftr.idArea = this.filtros.idArea
        const response = await reportService.getRelatorioGestao('ServidorMaisDoisVinculos', ftr, this.filtros.formato)
        //console.log('sm2v recebido', response)
        this.filename = "ServidoresMaisVinculos_" + this.filtros.exercicio + "_" + this.filtros.mes + "_" + this.filtros.ug;
        if (this.filtros.formato && this.filtros.formato === "excelopenxml") {
          const blob = this.base64ToBlob(response.ArquivoPdf, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
          this.download(this.filename, blob)
        } else { // tratar como PDF
          const blob = this.base64ToPdf(response.ArquivoPdf)
          const objectUrl = URL.createObjectURL(blob)
          this.pdfData = objectUrl;
        }
      } catch (e) {
        this.tratarError(e)
      } finally {
        this.loading = false;
      }
    }
  },

  async mounted() {
    this.meses = this.getListaMeses()
    await this.prepararSm2v()
  }

}
</script>

<style>
#cardFiltros {
  text-align: left;
  margin: 20px auto !important;
  width: 95%;
}
</style>